<template>
  <b-container fluid class="h-100 px-0" style="min-height: 100vh">
    <div
      :class="['content-login', 'h-100', fontClass]"
      style="min-height: 100vh"
    >
      <b-row
        cols-lg="3"
        cols-md="2"
        cols-sm="2"
        class="justify-content-center h-100 mx-0"
      >
        <b-col align-self="center">
          <b-card class="card-login">
            <b-dropdown
              class="language-dropdown"
              toggle-class="language-toggle"
              variant="light"
              right
              no-caret
            >
              <template #button-content>
                <b-icon icon="globe" aria-hidden="true" />
                <span class="sr-only">{{ copy.language }}</span>
              </template>

              <b-dropdown-item
                v-for="option in languageOptions"
                :key="option.value"
                :active="language === option.value"
                @click="language = option.value"
              >
                {{ option.text }}
              </b-dropdown-item>
            </b-dropdown>

            <b-img class="logo" alt="Vue logo" :src="logoSrc"></b-img>

            <h4 class="txt-white mb-4">{{ copy.package }}</h4>

            <b-form @submit.prevent="purchasePlan" class="max-35 px-1">
              <div class="subscription-options">
                <b-row class="justify-content-center">
                  <b-col
                    v-for="(plan, key) in planOptions"
                    :key="key"
                    cols="12"
                    md="6"
                    lg="4"
                    class="mb-3"
                  >
                    <b-card
                      :class="['plan-card', { selected: selectedPlan === key }]"
                      bg-variant="light"
                      text-variant="dark"
                      @click="selectedPlan = key"
                    >
                      <b-card-body class="d-flex flex-column">
                        <div
                          class="d-flex align-items-start justify-content-between"
                        >
                          <div style="flex: 1; min-width: 0">
                            <h5 class="mb-1">{{ plan.name }}</h5>
                            <div class="small text-muted">
                              {{ plan.description }}
                            </div>
                            <div class="small text-muted">
                              {{ plan.validity }}
                            </div>
                          </div>

                          <div class="d-flex flex-column align-items-end ml-3">
                            <div class="h5 mb-2">{{ plan.price }}</div>
                            <div>
                              <b-button
                                size="sm"
                                variant="success"
                                @click.stop.prevent="purchasePlan(key)"
                                class="btn-subs"
                              >
                                {{ copy.subscribe }}
                              </b-button>
                            </div>
                          </div>
                        </div>
                      </b-card-body>
                    </b-card>
                  </b-col>
                </b-row>
              </div>
            </b-form>

            <div class="mt-3 text-center d-flex justify-content-center">
              <span v-if="copy.install" class="txt-white">
                {{ copy.install }}
                <a
                  @click.prevent="openInstallLink"
                  class="txt-white"
                  style="
                    cursor: pointer;
                    text-decoration: underline;
                    margin-left: 6px;
                  "
                >
                  {{ copy.esim }}
                </a>
              </span>
            </div>

            <b-tooltip
              ref="tooltip"
              target="form-input-name"
              :disabled.sync="disabled"
            >
              <div class="tooltip-custom">{{ copy.unsupported }}</div>
            </b-tooltip>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <b-modal id="error-modal" title="Error" hide-footer>
      <div class="mb-3">
        {{ this.errorMessage || "An unexpected error occurred." }}
      </div>
      <b-button variant="primary" block @click="onErrorModalClose"
        >Close</b-button
      >
    </b-modal>
  </b-container>
</template>

<!-- SCRIPT LOGIC SECTION -->
<script>
import { mapActions, mapState } from "vuex";
import { apiMsg } from "@/provider";

export default {
  data() {
    return {
      disabled: true,
      language: "km",
      languageOptions: [
        { value: "en", text: "English" },
        // { value: "id", text: "Indonesia" },
        { value: "km", text: "កម្ពុជា" },
      ],
      translations: {
        en: {
          language: "Language",
          greeting: "Hi!",
          instruction: "To start playing, enter your mobile number here:",
          placeholder: "855xxxxx",
          login: "Login",
          unsupported: "This provider number is not supported.",
          install: "Need a cellcard phone number? ",
          link: "https://selfcareapp-links.cellcard.com.kh/?redirectTo=main/buyESim",
          esim: "Get eSIM",
          package: "Choose Package",
          subscribe: "Subscribe",
          confirm: "Confirm",
          confirmation: "Confirmation",
          enterPhoneNumber: "Enter Phone Number",
          expiredOtp: "OTP Expires in ",
          errorOtp: "Invalid OTP. Please try again",
          errorExpired: "OTP is expired. Please try again",
          errSUbs: "error susbcribe, please try again",
          errorOtpFailed: "Failed to send OTP. Please try again.",
          errorOtpMaxFailed: "Your OTP has reach limit",
        },
        id: {
          language: "Bahasa",
          greeting: "Hai!",
          instruction: "Untuk mulai main, masukkan nomor handphonemu di sini:",
          placeholder: "628xxxxxxxxx",
          login: "Login",
          unsupported: "Tidak mendukung nomor provider ini.",
          install: "",
          link: "",
          package: "Choose Package",
          subscribe: "Subscribe",
          confirm: "Confirm",
          confirmation: "Confirmation",
          enterPhoneNumber: "Enter Phone Number",
          expiredOtp: "OTP Kadaluarsa pada ",
          errorOtp: "Invalid OTP. Please try again",
          errorExpired: "OTP is expired. Please try again",
          errSUbs: "error susbcribe, please try again",
          errorOtpFailed: "Failed to send OTP. Please try again.",
          errorOtpMaxFailed: "Your OTP has reach limit",
        },
        km: {
          language: "ភាសា",
          greeting: "",
          instruction: "សូមបញ្ចូលលេខទូរស័ព្ទរបស់អ្នក",
          placeholder: "855xxxxxxxx",
          login: "ចូលគណនី",
          unsupported: "លេខរបស់ប្រតិបត្តិករនេះមិនត្រូវបានគាំទ្រទេ។",
          install: "តម្រូវការស៊ីមសែលកាតមែនទេ? ",
          link: "https://selfcareapp-links.cellcard.com.kh/?redirectTo=main/buyESim",
          esim: "ទិញ eSIM ឥឡូវនេះ",
          package: "សូមជ្រើសរើសកញ្ចប់",
          subscribe: "ភ្ជាប់",
          confirm: "បញ្ជាក់",
          confirmation: "បញ្ជាក់ការភ្ជាប់",
          enterPhoneNumber: "សូមបញ្ចូលលេខទូរស័ព្ទរបស់អ្នក",
          expiredOtp: "ផុតកំណត់ក្នុងរយៈពេល",
          errorOtp: "លេខ OTP មិនត្រឹមត្រូវ។ សូមព្យាយាមម្តងទៀត។",
          errSUbs: "មានបញ្ហាក្នុងការជាវ សូមព្យាយាមម្តងទៀត",
          errorOtpFailed: "បរាជ័យក្នុងការផ្ញើ OTP។ សូមព្យាយាមម្តងទៀត។",
          errorOtpMaxFailed: "លេខកូដ OTP របស់អ្នកបានដល់កម្រិតកំណត់ហើយ។",
          errorExpired: "លេខកូដ OTP បានផុតកំណត់ហើយ។ សូមព្យាយាមម្តងទៀត។",
        },
      },
      msisdn: null,
      token: null,
      form: {
        msisdn: null,
      },
      subscription_plan: {},
      selectedPlan: null,
      telcos: null,
      isLoading: false,
      redirectToLoginOnModalClose: false,
      a_table:
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
      b_table: null,
      errorMessage: null,
    };
  },
  mounted() {
    const savedLanguage = localStorage.getItem("loginLanguage");

    if (this.translations[savedLanguage]) this.language = savedLanguage;
    document.documentElement.lang = this.language;
    if (this.android && window.androidOrientation)
      window.androidOrientation.postMessage("portrait");
    this.b_table = this.a_table.split(" ").map(function (s) {
      return parseInt(s, 16);
    });
    this.loadPlans();
    this.hideAlert();
  },
  computed: {
    ...mapState(["telco", "secretKey", "android"]),
    copy() {
      return this.translations[this.language] || this.translations.km;
    },
    planOptions() {
      const lang = this.language === "km" ? "km" : "en";

      return Object.keys(this.subscription_plan).reduce((acc, key) => {
        const plan = this.subscription_plan[key];

        acc[key] = {
          ...plan,
          name:
            typeof plan.name === "object"
              ? plan.name[lang] || plan.name.en
              : plan.name,
          description:
            typeof plan.description === "object"
              ? plan.description[lang] || plan.description.en
              : plan.description,
          validity:
            typeof plan.validity === "object"
              ? plan.validity[lang] || plan.validity.en
              : plan.validity,
        };

        return acc;
      }, {});
    },
    logoSrc() {
      return require("@/assets/login-logo-kh.png");
    },
    fontClass() {
      if (this.language === "en") return "font-inter";
      if (this.language === "km") return "font-noto";
      return "";
    },
  },
  watch: {
    language(value) {
      localStorage.setItem("loginLanguage", value);
      document.documentElement.lang = value;
    },
  },
  methods: {
    ...mapActions([
      "getProfile",
      // 'getGames',
    ]),
    setStore() {
      this.$store.commit("SET_TOKEN", this.token);
      this.$store.commit("SET_USER", this.msisdn);
    },
    showAlert() {
      this.disabled = false;
      this.$refs.tooltip.$emit("open");
    },
    hideAlert() {
      this.disabled = true;
      this.$refs.tooltip.$emit("close");
    },

    openInstallLink() {
      const link = this.copy && this.copy.link;
      if (!link) return;
      try {
        window.open(link, "_blank", "noopener");
      } catch (e) {
        window.location.href = link;
      }
    },

    normalizePlanText(value, fallbackEn = "", fallbackKm = "") {
      if (value && typeof value === "object") {
        return {
          en: value.en || value.EN || value.eng || value.english || fallbackEn,
          km:
            value.km ||
            value.kh ||
            value.khm ||
            value.khmer ||
            value["km-KH"] ||
            fallbackKm,
        };
      }

      return {
        en: value || fallbackEn,
        km: fallbackKm || value || fallbackEn,
      };
    },

    extractPlanList(payload) {
      if (!payload) return [];

      if (Array.isArray(payload)) return payload;
      if (Array.isArray(payload.data)) return payload.data;
      if (Array.isArray(payload.body)) return payload.body;
      if (Array.isArray(payload.result)) return payload.result;
      if (Array.isArray(payload.items)) return payload.items;
      if (Array.isArray(payload.data?.data)) return payload.data.data;
      if (Array.isArray(payload.data?.items)) return payload.data.items;
      if (payload.data && typeof payload.data === "object") {
        const nested =
          payload.data.data ||
          payload.data.items ||
          payload.data.list ||
          payload.data.plans;
        if (Array.isArray(nested)) return nested;
      }
      if (payload && typeof payload === "object") {
        const candidate =
          payload.plans || payload.list || payload.items || payload.data;
        if (Array.isArray(candidate)) return candidate;
        if (candidate && typeof candidate === "object") {
          return Object.values(candidate);
        }
      }
      return [];
    },

    async loadPlans() {
      try {
        const response = await apiMsg.get("subscribe/plan");
        const list = this.extractPlanList(
          response && response.data ? response.data : response,
        );

        if (!list.length) return;

        const normalized = {};

        list.forEach((plan) => {
          const key = plan.key || plan.plan_key || plan.code || plan.id;
          if (!key) return;

          const name = this.normalizePlanText(
            plan.name,
            plan.name_en ||
              plan.nameEN ||
              plan.nameEnglish ||
              plan.name_english,
            plan.name_km || plan.nameKH || plan.nameKhmer || plan.name_kh,
          );
          const description = this.normalizePlanText(
            plan.description,
            plan.description_en ||
              plan.descriptionEN ||
              plan.description_english,
            plan.description_km || plan.descriptionKH || plan.description_kh,
          );
          const validity = this.normalizePlanText(
            plan.validity,
            plan.validity_en || plan.validityEN || plan.validity_english,
            plan.validity_km || plan.validityKH || plan.validity_kh,
          );

          normalized[key] = {
            key: key,
            name,
            description,
            validity,
            price: plan.price || plan.amount || plan.cost || "$0.00",
          };
        });

        if (Object.keys(normalized).length) {
          this.subscription_plan = normalized;
        }
      } catch (error) {
        this.errorMessage = this.copy.errSUbs;
        this.$bvModal &&
          this.$bvModal.show &&
          this.$bvModal.show("error-modal");
      }
    },

    // DIREC FUNCTION
    async purchasePlan(planKey) {
      const key = planKey || this.selectedPlan;
      if (!key) return;
      const plan = this.subscription_plan[key];
      if (!plan) {
        console.error("Plan not found:", key);
        return;
      }

      const msisdn = String(
        (this.$store && this.$store.state && this.$store.state.user) ||
          this.msisdn ||
          "",
      ).replace(/\D/g, "");

      const payload = {
        plan_id: plan.key || key,
        msisdn,
      };

      try {
        const response = await apiMsg.post("subscribe/cellcard", payload);
        const respData = response && response.data;

        if (respData && respData.status === "success") {
          this.$store.commit("SET_SELECTED_PLAN", { key, plan });

          if (respData.data && respData.data.transaction_id) {
            this.$store.commit(
              "SET_TRANSACTION_ID",
              respData.data.transaction_id,
            );
          }

          this.$router
            .push({ name: "otp-subs", query: { plan: key } })
            .catch(() => {});
          return;
        }

        throw new Error(
          (respData && (respData.message || respData.error)) ||
            "Subscription request failed",
        );
      } catch (e) {
        const errorMessage = e?.response?.data?.error || "";
        if (errorMessage.includes("cellcard subscribe error 0002")) {
          this.isCellcardError0002 = true;
          this.redirectToLoginOnModalClose = true;
          this.errorMessage = this.copy.errorOtpMaxFailed;
        } else if (
          errorMessage.includes("msisdn is suspended due to OTP fail limit")
        ) {
          this.isCellcardError0002 = true;
          this.redirectToLoginOnModalClose = true;
          this.errorMessage = this.copy.errorOtpMaxFailed;
        } else if (
          errorMessage.includes("cellcard confirm error 0004: FAILURE")
        ) {
          this.errorMessage = this.copy.errorOtp;
        } else if (
          errorMessage.includes("cellcard confirm error 0003: FAILURE")
        ) {
          this.errorMessage = this.copy.errorExpired;
        } else if (errorMessage.includes("invalid or expired otp")) {
          this.errorMessage = this.copy.errorOtp;
        } else if (
          errorMessage.includes("cellcard confirm error 0005: FAILURE")
        ) {
          this.isCellcardError0002 = true;
          this.errorMessage = this.copy.errorOtpMaxFailed;
        } else {
          this.errorMessage = this.copy.errorOtpFailed;
        }

        // this.errorMessage = this.copy.errSUbs;
        this.$bvModal &&
          this.$bvModal.show &&
          this.$bvModal.show("error-modal");
      }
      this.hideAlert();
    },

    b_crc32(str) {
      var crc = -1;
      for (var i = 0, iTop = str.length; i < iTop; i++) {
        crc = (crc >>> 8) ^ this.b_table[(crc ^ str.charCodeAt(i)) & 0xff];
      }
      return (crc ^ -1) >>> 0;
    },

    onErrorModalClose() {
      this.$bvModal.hide("error-modal");
      if (this.redirectToLoginOnModalClose) {
        this.redirectToLoginOnModalClose = false;
        this.$router.push({ name: "login" }).catch(() => {});
      }
    },
  },
};
</script>

<!-- STYLE SECTION -->
.style-font-imports { }
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400;700&family=Noto+Sans+Khmer:wght@400;700&display=swap");

.content-login {
  min-height: 100vh;

  background-color: #0b40a2;

  background-image: linear-gradient(
      to top,
      rgba(0, 0, 0, 0.75) 0%,
      rgba(0, 0, 0, 0.45) 25%,
      rgba(0, 0, 0, 0.15) 50%,
      rgba(0, 0, 0, 0) 75%
    ),
    url("../assets/login-logo-mobile.png");

  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}

.card-login {
  background-color: transparent;
  border: none;
  position: relative;
}
.language-dropdown {
  position: absolute;
  right: 23px;
  top: 10px;
  z-index: 2;
}
.language-dropdown::v-deep .language-toggle {
  align-items: center;
  border-radius: 50%;
  display: inline-flex;
  height: 42px;
  justify-content: center;
  padding: 0;
  width: 42px;
}
.logo {
  height: 30vh;
  max-height: 320px;
  margin-top: 60px;
}
.txt-white {
  color: white;
}
.tooltip-custom {
  font-size: 0.8rem !important;
  max-width: 300px !important;
  padding: 0.5rem !important;
}

.font-inter {
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
}

.font-noto {
  font-family: "Noto Sans Khmer", "Noto Sans", sans-serif;
}

.btn-subs {
  cursor: pointer;
  transition: box-shadow 160ms ease, transform 120ms ease;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 20px;
}
.plan-card {
  cursor: pointer;
  transition: box-shadow 160ms ease, transform 120ms ease;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 20px;
  text-align: left;
}
.plan-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.35);
}
.plan-card.selected {
  border-color: rgba(255, 255, 255, 0.18);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.45);
}

/* Reduce internal spacing for plan cards */
.plan-card .card-body {
  padding: 10px 12px !important;
}
.plan-card h5 {
  font-weight: bold;
  font-size: 1.3rem;
  margin-bottom: 6px;
}
.plan-card .small {
  margin-bottom: 4px;
}
.plan-card .btn {
  padding: 0.28rem 0.9rem;
  font-size: 0.85rem;
}
</style>
